/* Represents the different status a store item might go through before the data is ready for use */
const status = Object.freeze({
  PENDING: 0,
  LOADING: 1,
  SUCCESS: 2,
  FAIL: 3,
});

export default status;
